import React, { useState, useEffect } from 'react';

import search from '../../../shared/assets/svg/search.svg';

const Search = ({ query, onChange, onClick, placeholder, className = '' }) => {
  /* 
    Local state
  */
  const [searchQuery, setSearchQuery] = useState(query || '');

  // Sync internal state with external query prop
  useEffect(() => {
    setSearchQuery(query || '');
  }, [query]);

  /*
    Event handlers 
  */
  const handleSearchChange = (e) => {
    // console.log(e.target.value)
    setSearchQuery(e.target.value);
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div
      className={`flex h-[2.57rem] w-full min-w-[10rem] max-w-[24rem] items-center rounded-md border border-gray-500 px-2 relative ${className}`.trim()}>
      <input
        type="text"
        name=""
        placeholder={placeholder || 'Search here...'}
        className="min-w-0 w-full p-1 outline-none"
        value={searchQuery}
        onChange={handleSearchChange}
      />
      <img
        onClick={onClick}
        src={search}
        alt="search_icon"
        className="h-4 w-4 shrink-0 cursor-pointer"
      />
    </div>
  );
};

export default Search;
